module.exports = __webpack_public_path__ + "static/media/2-R-Smart Mate.17168106.jpg";